import GraphqlAPI from '../GraphqlAPI'

export const graphqlAPIRequester = async ({ input, func }) => {
  const { data } = await GraphqlAPI(func(input))
  return data
}
